import { render, staticRenderFns } from "./PhysicianInfo.vue?vue&type=template&id=001daa50&scoped=true&"
import script from "./PhysicianInfo.vue?vue&type=script&lang=js&"
export * from "./PhysicianInfo.vue?vue&type=script&lang=js&"
import style0 from "./PhysicianInfo.vue?vue&type=style&index=0&id=001daa50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001daa50",
  null
  
)

component.options.__file = "PhysicianInfo.vue"
export default component.exports